export enum CreditTransferReportType {
  REPORT_SUBTYPE_COMBINED = 'REPORT_SUBTYPE_COMBINED',
  REPORT_SUBTYPE_SEPARATED = 'REPORT_SUBTYPE_SEPARATED',
  DETAILS_ORDER_REPORT = 'DETAILS_ORDER_REPORT',
  OVERVIEW_ORDER_REPORT = 'OVERVIEW_ORDER_REPORT',
}
